import React from 'react'
import { useStyles } from './style'

export default function CodeSnippet ({ children }) {
  const classes = useStyles()
  return <code className={classes.root}>{children}</code>
}
